var global_isSignedIn =
{
 isSignedIn: false

}

export default global_isSignedIn;